import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import DependentEntitiesSelector, { commonPropTypes } from "./dependent-entities-selector";
import gql from "graphql-tag";

const query = `
  query GraphicsetsByContractId($contractId: ID, $customerId: ID) {
    graphicsetsByContractId(contractId: $contractId, customerId: $customerId) {
      items {
        id
        name
      }
      total
    }
  }
`;

export const graphicsetsByContractIdQuery = gql`
  ${query}
`;

const GraphicSetSelectByContract = ({
  multiple = false,
  id = "graphicSetId",
  name = "graphicSetId",
  contractId,
  isInsideForm,
  onChange,
  eventGraphicSetId,
  ...props
}) => {
  const handleDataFromResponse = useCallback(data => data.graphicsetsByContractId, []);
  const handleGetValue = useCallback(element => element.id, []);
  const handleGetLabel = useCallback(element => element.name, []);

  const [dependencyId, setDependencyId] = useState(contractId);

  useEffect(
    () => {
      if (contractId !== dependencyId) {
        setDependencyId(contractId);
        onChange({ id: null });
      }
    },
    [contractId, dependencyId, onChange],
  );

  return (
    <DependentEntitiesSelector
      disabled={!contractId}
      queryParams={{
        contractId,
      }}
      skip={!contractId}
      isInsideForm={isInsideForm}
      multiple={multiple}
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      onChange={onChange}
      {...props}
    />
  );
};

GraphicSetSelectByContract.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del texto de la opción vacía, si existe (opcional)
   */
  emptyValueText: PropTypes.string,
};

export default GraphicSetSelectByContract;
